import {
  handleToggleArrowKeys,
  handleMenuArrowKeys,
} from "../utils/menuKeyNav.js";

export default class NavSubnav {
  constructor(el) {
    this.root = el;
    this.toggle = el.querySelector(".js--subnav-toggle");
    this.menu = el.querySelector(".js--subnav-menu");

    if (!this.toggle || !this.menu) return;

    this.isOpen = false;
    this.menuLinks = Array.from(this.menu.querySelectorAll("a"));

    this.menu.id = "subnav-menu";
    this.toggle.setAttribute("aria-expanded", "false");
    this.toggle.setAttribute("aria-controls", "subnav-menu");

    this.bindEvents();
  }

  open() {
    this.isOpen = true;
    this.root.classList.add("nav-subnav--is-open");
    this.toggle.setAttribute("aria-expanded", "true");
  }

  close() {
    this.isOpen = false;
    this.root.classList.remove("nav-subnav--is-open");
    this.toggle.setAttribute("aria-expanded", "false");
  }

  bindEvents() {
    this.toggle.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });

    this.toggle.addEventListener("keydown", (e) =>
      handleToggleArrowKeys(e, {
        items: this.menuLinks,
        open: (target) => {
          if (!this.isOpen) this.open();
          target.focus();
        },
      }),
    );

    this.menu.addEventListener("keydown", (e) =>
      handleMenuArrowKeys(e, { toggle: this.toggle, items: this.menuLinks }),
    );

    this.root.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
        this.toggle.focus();
      }
    });

    this.root.addEventListener("focusout", (e) => {
      if (!this.root.contains(e.relatedTarget)) {
        this.close();
      }
    });
  }
}
